import React from 'react'

interface MetricsGridProps {
  completenessScore: number
  timelinessScore: number
  qualityScore: number
  schemaScore: number
  duplicatesScore: number
  completenessTrend: { percentage: number; isPositive: boolean }
}

const MetricsGrid: React.FC<MetricsGridProps> = ({
  completenessScore,
  timelinessScore,
  qualityScore,
  schemaScore,
  duplicatesScore
}) => {
  const getColor = (score: number): string => {
    if (score > 95) return '#22c55e'  // Green - > 95%
    if (score >= 90) return '#f59e0b'  // Yellow - 90-95%
    return '#ef4444'  // Red - < 90%
  }

  const getDuplicatesColor = (score: number): string => {
    if (score < 5) return '#22c55e'  // Green - < 5%
    if (score < 10) return '#f59e0b'  // Yellow - 5-10%
    return '#ef4444'  // Red - >= 10%
  }

  return (
    <div className="file-metrics-section">
      <h3 className="section-title">Metrics</h3>
      <div className="inline-metrics-grid">
        <div className="inline-metric-item">
          <span className="inline-metric-label">Completeness:</span>
          <span className="inline-metric-value" style={{ color: getColor(completenessScore) }}>
            ● {completenessScore.toFixed(1)}%
          </span>
        </div>
        <div className="inline-metric-item">
          <span className="inline-metric-label">Timeliness:</span>
          <span className="inline-metric-value" style={{ color: getColor(timelinessScore) }}>
            ● {timelinessScore.toFixed(1)}%
          </span>
        </div>
        <div className="inline-metric-item">
          <span className="inline-metric-label">Quality:</span>
          <span className="inline-metric-value" style={{ color: getColor(qualityScore) }}>
            ● {qualityScore.toFixed(1)}%
          </span>
        </div>
        <div className="inline-metric-item">
          <span className="inline-metric-label">Schema:</span>
          <span className="inline-metric-value" style={{ color: getColor(schemaScore) }}>
            ● {schemaScore.toFixed(1)}%
          </span>
        </div>
        <div className="inline-metric-item">
          <span className="inline-metric-label">Duplicates:</span>
          <span className="inline-metric-value" style={{ color: getDuplicatesColor(duplicatesScore) }}>
            ● {duplicatesScore.toFixed(1)}%
          </span>
        </div>
      </div>
    </div>
  )
}

export default MetricsGrid
